<!--
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-27 11:30:29
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-04 11:37:40
 * @FilePath: /lobby/src/components/NavBar.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div v-if="isLogin || !showTips" class="nav-bar" @click="onTouchFooter">
    <div v-for="(item, i) in menus" @click="onTouch(item)" :key="i">
      <li v-if="i != 2" :class="{ active: item.path === getCurrentRouter() }">
        <i v-if="item.iconClass" :class="item.iconClass"></i>
        <img
          v-else
          :src="item.path === getCurrentRouter() ? item.selectUrl : item.iconUrl"
          alt=""
        />
        <p>{{ $t(item.name) }}</p>
      </li>
      <li v-else>
        <div class="circle">
          <i v-if="item.iconClass" :class="item.iconClass"></i>
          <img
            v-else
            :src="item.path === getCurrentRouter() ? item.selectUrl : item.iconUrl"
            alt=""
          />
        </div>
        <p>{{ $t(item.name) }}</p>
      </li>
    </div>
  </div>
  <div v-else-if="showTips" class="login-layout">
    <div class="login-close"><i class="bi bi-x" @click="showTips = false"></i></div>
    <div class="text-content" v-if="country != 'TZ'">
      {{ $t('login.tips', { bonusAmount: bonusAmount[country] || 0 }) }}
    </div>
    <div class="btn-group">
      <div class="login-btn" @click="onShowLogin">{{ $t('userBar.login').toUpperCase() }}</div>
      <div style="height: 0.5rem" />
      <div class="register-btn" @click="onShowRegister">
        {{ $t('userBar.register').toUpperCase() }}
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/common/config'
import { BUS, POPUP } from '@/event/EventCenter'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { mapActions, mapState } from 'pinia'
import { useRoute } from 'vue-router'
import { getLocalStorage, Key } from '@/common/localStorage'

export default {
  data() {
    return {
      route: useRoute(),
      menus: [
        {
          name: 'navBar.home',
          path: '/',
          iconClass: 'bi bi-house'
        },
        {
          name: 'navBar.promotion',
          path: '/promotion',
          iconClass: 'bi bi-gift'
        },
        {
          name: 'navBar.deposit',
          path: '/deposit',
          iconClass: 'bi bi-wallet2'
        },
        {
          name: 'navBar.withdraw',
          path: '/withdraw',
          iconClass: 'bi bi-cash-stack'
        },
        {
          name: useUserStore().country == 'KE' ? 'navBar.poker' : 'navBar.game',
          path: '/events',
          iconClass: useUserStore().country == 'KE' ? 'bi-controller' : null, //'bi bi-gift'
          iconUrl: `${config.resBaseUrl}${useUserStore().country == 'KE' ? 'airplane1' : 'ball-football-icon1'}.svg`,
          selectUrl: `${config.resBaseUrl}${useUserStore().country == 'KE' ? 'airplane2' : 'ball-football-icon2'}.svg`
        }
        // {
        //   name: 'navBar.acting',
        //   path: '/acting',
        //   iconClass: 'bi bi-person-raised-hand'
        // }
      ],
      showTips: false,
      bonusAmount: {
        ET: '20,000',
        CI: '40,000',
        KE: '10,000'
      },
      cd: 0
    }
  },
  computed: {
    ...mapState(useUserStore, ['isLogin', 'country'])
  },
  mounted() {
    setInterval(() => {
      this.cd++
    }, 1000)
    if (!this.isLogin && getLocalStorage(Key.agentcode)) {
      setTimeout(() => {
        this.onShowRegister()
      }, 500)
    }
  },
  methods: {
    ...mapActions(useLobbyStore, {
      enterGame: 'enterGame'
    }),
    onTouchFooter() {
      this.$bus.$emit(BUS.SHOW_MENU, false)
    },
    onTouch(item) {
      if (this.cd < 1) {
        return
      }
      this.cd = 0
      if (item.path == '/events') {
        // showSuccessToast({
        //   message: this.$t('common.tips'),
        //   wordBreak: 'break-word',
        //   duration: 3000
        // })
        this.enterSportGame()
      } else {
        if (this.isLogin) {
          if (item.path == '/deposit') {
            if (this.country == 'CI') {
              this.$router.replace('/depositci')
            } else if (this.country == 'KE') {
              this.$router.replace('/depositke')
            } else if (this.country == 'TZ') {
              this.$router.replace('/deposittz')
            } else if (this.country == 'GH') {
              this.$router.replace('/depositgh')
            } else {
              this.$router.replace('/deposit')
            }
          } else if (item.path == '/withdraw') {
            if (this.country == 'TZ') {
              this.$router.replace('/withdrawtz')
            } else if (this.country == 'ET') {
              this.$router.replace('/withdrawet')
            } else if (this.country == 'GH') {
              this.$router.replace('/withdrawgh')
            } else {
              this.$router.replace('/withdraw')
            }
          } else {
            this.$router.replace(item.path)
          }
          this.$bus.$emit(BUS.FULL_SCREEN, false)
        } else {
          if (item.path == '/promotion' || item.path == '/') {
            this.$router.replace(item.path)
          } else {
            this.$router.replace('/')
            this.$bus.$emit(BUS.SHOW_POPUP, {
              from: item.path.replace('/', ''),
              to: POPUP.LOGIN,
              show: true
            })
          }
        }
      }
    },
    enterSportGame() {
      const env = import.meta.env.VITE_APP_ENV
      const gameconfig = {
        staging: {
          ET: 10191,
          CI: 10197,
          KE: 30001, //30025
          TZ: 50040
        },
        app_staging: {
          ET: 10191,
          CI: 10197,
          KE: 30001, //30025
          TZ: 50040
        },
        production: {
          ET: 10021,
          CI: 20021,
          KE: 30001, //30004
          TZ: 50040,
          GH: 40040,
        },
        app: {
          ET: 10021,
          CI: 20021,
          KE: 30001, //30004
          TZ: 50040
        }
      }
      let gameId = parseInt(gameconfig[env][this.country])
      this.enterGame(gameId).then((response) => {
        // this.currentGameUrl = response.url
        // this.showFooter = true
        this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
      })
    },
    getCurrentRouter() {
      let currentPage = this.route.path
      if (
        currentPage == '/depositci' ||
        currentPage == '/depositke' ||
        currentPage == '/deposittz' ||
        currentPage == '/depositgh'
      ) {
        currentPage = '/deposit'
      }
      if (
        currentPage == '/withdraw' ||
        currentPage == '/withdrawet' ||
        currentPage == '/withdrawtz' ||
        currentPage == '/withdrawgh'
      ) {
        currentPage = '/withdraw'
      }
      return currentPage
    },
    onShowLogin() {
      this.showTips = false
      this.$bus.$emit(BUS.SHOW_POPUP, {
        to: POPUP.LOGIN,
        from: 'navbar',
        show: true
      })
    },
    onShowRegister() {
      this.$bus.$emit(BUS.SHOW_POPUP, {
        to: POPUP.REGISTER,
        from: 'navbar',
        show: true
      })
      this.showTips = false
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  width: 100%;
  height: var(--nav-bar-height);
  background-color: #2d3e50;
  position: fixed;
  z-index: 11;
  bottom: 0;

  li {
    font-size: 0.24rem;
    color: #95a5a5;
    text-align: center;
    display: block;
    float: left;
    width: 20%;
    margin: 0;
    padding-top: 0.21rem;
    border-radius: 0.14rem 0.14rem 0 0;
    height: 100%;

    i {
      font-size: 0.3rem;
      color: #95a5a5;
    }

    p {
      margin-top: 0.08rem;
      font-size: 0.23rem;
      line-height: 1;
    }

    img {
      // width: 0.23rem;
      height: 0.3rem;
      // margin-bottom: 0.08rem;
    }

    &.active {
      background-color: #ceb45f;
      color: #fff !important;

      i {
        color: #fff !important;
      }
    }

    .circle {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 0.9rem;
      height: 0.9rem;
      background: #825c2d;
      background: linear-gradient(145deg, #ceb45f 5%, #825c2d, #ceb45f 50%, #825c2d, #ceb45f 95%);
      background-size: 300% 300%;
      animation: gradientBG 2s linear infinite;
      border-radius: 50%;
      border: 0.15rem solid #2d3e50;
      margin-top: -0.7rem;
      margin-left: 0.15rem;
      margin-bottom: -0.1rem;

      i {
        color: #fff !important;
      }

      img {
        width: 0.23rem;
        margin-bottom: 0.08rem;
      }
    }
  }
}

.login-layout {
  width: 100%;
  // height: var(--nav-bar-height);
  background-color: #2d3e50;
  position: fixed;
  z-index: 1000;
  bottom: 0;

  .login-close {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: -0.1rem;

    i {
      font-size: 0.6rem;
    }
  }

  .text-content {
    width: 100%;
    height: 0.3rem;
    font-family: Droid Sans;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffdda9;
    line-height: 0.22rem;
    text-align: center;
  }

  .btn-group {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    .login-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 6rem;
      height: 1rem;
      background: rgba(170, 136, 74, 0);
      border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
      border: 0.02px solid #aa884a;

      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.3rem;
      color: #aa884a;
      line-height: 0.22rem;
    }

    .register-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 6rem;
      height: 1rem;
      background: #aa884a;
      border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;

      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.22rem;
    }
  }
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: 100% 100%;
  }
}
</style>
